const port = {
    biz:'/eceping-biz',
    course:'/eceping-course',
    stat:'/eceping-stat',
    exam:'/eceping-exam',
    cms:'/eceping-cms',
}
export default port


// WEBPACK FOOTER //
// ./src/apiCloud/port.js